import * as ng from 'angular';
import { ComponentRegistration } from '../../../core';
import { Dto } from '../../../data';
import { IToastMessageService } from '../../../services';
import { IUserAdminService } from './../';
let template = require('./users-detail.html');

class UsersDetailComponent extends ComponentRegistration {

    constructor() {
        super('usersDetail', {
            controller: UsersDetailController,
            templateUrl: template,
            controllerAs: 'vm',
            bindings: {
                originalUser: '<?user',
                add: '<?',
                onCancel: '&?',
                onSave: '&?',
                onLoadUserCancel: '&?'
            }
        });
    }
}

interface IUsersDetailController {

}

class UsersDetailController implements IUsersDetailController {
    private static $inject: Array<string> = ['UserAdmin', '$mdDialog', '$timeout'];
    private user: Dto.IProfile;
    //private _email: string;
    private userForm: ng.IFormController;
    private emailModified: boolean;
    private usernameExists: boolean;
    private criteria: Dto.IProfileCriteria;
    private inEditMode: boolean;
    private hasChanges: boolean;
    //Bindings
    private _originalUser: Dto.IProfile;
    private onCancel: Function;
    private onSave: Function;
    private onLoadUserCancel: Function;
    private loseChangesMessage = "Changes will be lost. Are you sure?";
    private add: boolean;

    constructor(private UserAdmin: IUserAdminService,
        private $mdDialog: ng.material.IDialogService,
        private $timeout: ng.ITimeoutService) {
        console.log('UsersFormController loading');
        this.activate();
    }

    public $onInit(): void {
        this.inEditMode = false;
        this.add = false;
        this.emailModified = false;
        this.usernameExists = false;
        this.hasChanges = false;
    }

    public get originalUser() {
        return this._originalUser;
    }

    public set originalUser(val: Dto.IProfile) {
        if (this._originalUser !== val && this.user !== val) {
            if (this.hasChanges) {
                var self = this;

                var confirm = this.$mdDialog.confirm()
                    .title('Warning')
                    .textContent(this.loseChangesMessage)
                    .ok('Yes')
                    .cancel('No');

                this.$mdDialog.show(confirm).then(
                    () => { self.acceptUserLoad(val); },
                    () => { self.onLoadUserCancel({ user: this.user }); }
                );                

            }
            else {
                this.acceptUserLoad(val);
            }
        }
    }

    private acceptUserLoad(val: Dto.IProfile) {
        this._originalUser = val;
        this.user = ng.copy(this._originalUser);
        this.inEditMode = !this.user.id;
        this.hasChanges = false;
        this.resetFormState();
    }

    public get userDisplayName() {
        if (this.originalUser) {
            return (this.originalUser.id)
                ? this.originalUser.firstName + " " + this.originalUser.lastName
                : "Add User";
        }
        return "No User Selected";
    }

    public get isNew() {
        return (this.user && !this.user.id);
    }

    public activate(): void {
        console.log('UsersFormController loaded');
    }

    public openMenu($mdMenu, ev) {
        $mdMenu.open(ev);
    };

    public get username() {
        return (this.user)
            ? this.user.username
            : undefined;
    }

    public set username(val: string) {

        if (this.user && val != this.user.username) {
            this.user.username = val;

            if (this.user.username)
                this.user.username = this.user.username.trim();

            // Do not check is username exists, if it is null or empty string.
            if (this.isNew && this.user.username && (this.userForm as any).username.$valid) {
                this.checkUsernameInUse(this.user.username);
            }
        }
    }

    public onEmailChange(): void {
        if (this.emailModified === false) {
            this.user.email = this.user.username;
        }
    }

    public checkUsernameInUse(username: string): void {
        this.UserAdmin.exists(username)
            .then((response) => {
                this.usernameExists = response;
            })
            .catch((e) => {
                console.log(e);
            });
    }

    public onResendInvite(): void {
        this.UserAdmin.sendInvite(this.user.id, this.user.username)
            .then((response) => {
                var x = response;
            })
    }

    public onUnlockUser(): void {
        this.UserAdmin.unlockUser(this.user.id);
    }

    public onCancelClick(args): void {
        let self = this;
        let completeCancel = () => {
            this.inEditMode = false;
            this.emailModified = false;
            this.user = ng.copy(this.originalUser)
            this.resetFormState();
            args.completeCancel();
            this.raiseCancel();
            this.hasChanges = false;
        }

        if (this.hasChanges) {

            var confirm = this.$mdDialog.confirm()
                .title('Warning')
                .textContent(this.loseChangesMessage)
                .ok('Yes')
                .cancel('No');

            this.$mdDialog.show(confirm).then(
                () => { completeCancel(); },
                () => { self.onLoadUserCancel({ user: this.user }); }
            );
        }
        else {
            completeCancel();
        }

    }

    private resetFormState() {
        this.userForm.$setPristine();
        this.userForm.$setUntouched();
        this.usernameExists = false;
    }

    public onSaveClick(args): void {
        if (!this.user) return;

        let userSavedHandler = (user) => {
            this.user = user;
            this._originalUser = ng.copy(user);
            this.inEditMode = false;
            this.hasChanges = false;
            this.raiseSave(this.originalUser);
            this.resetFormState();
            console.log("Profile Update Successful");
        };

        let userCatchHandler = (e) => {
            args.cancel();
            console.log(e);
        };

        if (this.user.id) {
            this.UserAdmin.update(this.user)
                .then(userSavedHandler)
                .catch(userCatchHandler);
        }
        else {
            this.UserAdmin.save(this.user)
                .then(userSavedHandler)
                .catch(userCatchHandler);
        }
    }

    public raiseSave(user: Dto.IProfile): void {
        if (typeof this.onSave === 'function') {
            this.onSave({
                user: user
            });
        }
    }

    public raiseCancel(): void {
        if (typeof this.onCancel === 'function') {
            this.onCancel({
                action: (this.user && this.user.id)
                    ? "edit"
                    : "add"
            });
        }
    }
}

let usersDetailComponent = new UsersDetailComponent();
export default usersDetailComponent;
export { usersDetailComponent as UsersDetailComponent, IUsersDetailController, UsersDetailController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/admin/users/users-detail.ts